import * as XLSX from 'xlsx'
import { keys, values } from 'lodash'

export const downloadFile = (name, type, data) => {
    const blob = new Blob([data], { type })
    const a = document.createElement('a')
    a.download = name
    a.href = window.URL.createObjectURL(blob)
    a.dispatchEvent(new MouseEvent('click', { view: window, bubbles: true, cancelable: true }))
    a.remove()
}

export const responseFileName = (response, fallback) => {
    const disposition = response?.headers?.['content-disposition'] ?? ''
    const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition)
    return match ? decodeURIComponent(match[1]) : fallback
}

export const downloadType = (type, data) => {
    const key = keys(data.header)
    const datasCsv = data.data.map(d => key.map(e => d[e]))
    const worksheet = XLSX.utils.aoa_to_sheet([values(data.header), ...datasCsv])
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, data.name)
    const excelBuffer = XLSX.write(workbook, { bookType: type, type: 'array' })
    downloadFile(
        `${data.name}.${type}`,
        type === 'xlsx'
            ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
            : 'text/csv;charset=utf-8',
        excelBuffer
    )
}
